import { faEnvelope, faKey, faUserShield, faEye, faEyeSlash, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CryptoJS from "crypto-js";
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { connect } from "react-redux";
import STSComponent from "../../components/STSComponent/STSComponent";
import { globals } from '../../globals';
import StatescapeLogo from "../../images/statescape-logo.png";
import LoginIcon from "../../images/statescape-signon.png";
import { forgotPw, validateCode, updateStrongPw } from "../../store/reducers/auth";
import "./css/ForgotPassword.scss";

class ForgotPassView extends STSComponent {
  constructor(props) {
    super(props);

    const localData = localStorage.getItem("logData");
    sessionStorage.removeItem("modalSinglePage");

    let newObj = {
      email: "",
      code: "",
      pword: "",
      passVisibilityIcon: faEye,
    };

    if (localData) {
      const decrypted = CryptoJS.AES.decrypt(
        localData.toString(),
        "myAuthCookie"
      );
      newObj = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
    }

    this.urlSearch = window.location.search;

    this.state = {
      email: newObj.email,
      code: newObj.code, 
      pword: newObj.pword,
      passVisibilityIcon: newObj.passVisibilityIcon, 
      countOfSubmission: 0,
      sentEmail: false, 
      isChecked: false,
      getTkClicked: false,
  };

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleCodeChange = this.handleCodeChange.bind(this);
    this.handlePwordChange = this.handlePwordChange.bind(this);
    this.togglePassVisibilityChange = this.togglePassVisibilityChange.bind(this);
    this.onEnterPress = this.onEnterPress.bind(this);
    this.getTk = this.getTk.bind(this);
    this.sendCode = this.sendCode.bind(this);
    this.sendPwd = this.sendPwd.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // if (!nextProps.successSubmit && !nextProps.isLoggingIn) {
    //   this.setState({ countOfSubmission: this.state.countOfSubmission + 1 });
    // }
    if (this.props !== nextProps) {
      if (nextProps.displayMode == "gologon"){
        setTimeout(() => {
          this.props.history.push("/login");
        }, 12000);
      }
    }    
  }

  handleEmailChange = (event) => {
    this.setState({ email: event.target.value });
  };

  handleCodeChange = (event) => {
    this.setState({ code: event.target.value });
  };

  handlePwordChange = (event) => {
    this.setState({ pword: event.target.value });
  };

  togglePassVisibilityChange = (event) => {
    const { passVisibilityIcon} = this.state;
    this.setState({ passVisibilityIcon: passVisibilityIcon == faEye ? faEyeSlash : faEye });
  };

  getTk = () => {
    const { email } = this.state;    
    const initialMode = window.location.pathname && window.location.pathname.indexOf('forgotpw') > -1 ? 'password' : 'username';
    event.preventDefault();
    this.props.forgotPw(email, initialMode);
    this.setState({ getTkClicked: true });
  };

  sendCode = () => {
    const { email, code } = this.state;
    const { otuData, displayMode } = this.props;
      
    const expireDate = otuData ? otuData.ExpireDate : null;
    const cToken1 = otuData ? otuData.CToken1 : null;

    event.preventDefault();
    this.props.validateCode(email, displayMode, code, cToken1);
  };

  sendPwd = () => {
    const { email, pword } = this.state;
    const { otuData, displayMode } = this.props;

    const expireDate = otuData ? otuData.ExpireDate : null;
    const cToken1 = otuData ? otuData.CToken1 : null;
    const cToken2 = otuData ? otuData.CToken2 : null;
    
    event.preventDefault();
    this.props.updateStrongPw(email, displayMode, cToken1, cToken2, pword);
    // this.setState({ pword: "" });
    // this.setState({ code: "" });
    // this.setState({ email: "" });
  }

  onEnterPress = (event) => {
    if (event && event.which === 13) {
      this.getTk();
    }
  };

  onSubmitCodePress = (event) => {
    if (event && event.which === 13) {
      this.sendCode();
    }
  };

  onSubmitNewPassword = (event) => {
    if (event && event.which === 13) {
      this.sendPwd();
    }
  };

  componentDidMount() {
    if (this.urlSearch) {
      var searchParams = new URLSearchParams(this.urlSearch);
      // report variables may be passed in from unathenticated users 
      // accessing the services website. 
      // const pageId = searchParams.get("pageid");  
     }
  }

  renderTitle = () => {
      const { email } = this.state;
      const { displayMode } = this.props;      

      if(displayMode){
        switch (displayMode) {
            case "entercode":
                return <Fragment>
                    <h3 className="forgot-form-heading">Enter the code</h3>
                    <div className="forgot-nav-text">We will email a temporary code to {email} if it is associated with an active account. </div>
                    </Fragment>;
            case "enterpass": 
                return <Fragment>
                    <h3 className="forgot-form-heading">Enter a new password</h3>
                    <div className="forgot-nav-text" style={{fontWeight: '500'}}>Passwords must be 7 characters in length and contain an uppercase (capital) letter, a lowercase letter and at least one number (or special character).  </div>
                    {/* <div className="forgot-nav-text">New Passwords must be 7 characters (or longer) and contain at least one of the following:  
                      <ul>
                        <li>An uppercase/capital letter. </li>
                        <li>A lowercase letter. </li>
                        <li>A number (or special character like #, @, $, &, etc.)</li>
                      </ul>
                    </div> */}

                    </Fragment>;
            case "gologon": 
                return <Fragment>
                    <h3 className="forgot-form-heading">Password updated</h3>
                    <div className="forgot-nav-text">Your password has been updated. <a href="/login">Click here to sign in with your new password</a>. </div>
                    </Fragment>;
            case "usernamesent": 
                return <Fragment>
                    <h3 className="forgot-form-heading">Email sent</h3>
                    <div className="forgot-nav-text">We will email the username to {email} if it is associated with an active account. <a href="/login">Click here to sign in</a>. </div>
                    </Fragment>;
            default:
                return <h3>Statescape authentication title</h3>;
        }
      }else{
        const initialMode = window.location.pathname && window.location.pathname.indexOf('forgotpw') > -1 ? 'password' : 'username';
        switch (initialMode) {
            case "password":
                return <Fragment>
                    <h3 className="forgot-form-heading">Forgot your password?</h3>
                    <div className="forgot-nav-text">Please enter the email address linked to your account.</div>
                    </Fragment>;
            case "username":
                return <Fragment>
                    <h3 className="forgot-form-heading">Forgot your username?</h3>
                    <div className="forgot-nav-text">Please enter the email address linked to your account.</div>   
                    </Fragment>;
            default:
                return <h3>Statescape</h3>;
        }
      }
  };

  renderBody = () => {
      const { email, code, pword, passVisibilityIcon} = this.state;
      const { otuData, displayMode, isInvalidCode, isInvalidPassword, reasonMessage } = this.props;
      
      const expireDate = otuData ? otuData.ExpireDate : null;
      const cToken1 = otuData ? otuData.CToken1 : null;

      const codeButtonDisable = code.length >= 5 ? "" : "disabled";

      const matchEmailRegExp = /[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;      
      const emailButtonDisable = email.match(matchEmailRegExp) ? "" : "disabled";

      const matchPasswordRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d\W]).{6,}$/;
      const saveButtonDisable = pword.match(matchPasswordRegExp) ? "" : "disabled";


      if(displayMode){
        switch (displayMode) {
            case "entercode":
                return <form onSubmit={this.sendCode}>
                    { isInvalidCode ? (
                      <div className="invalid-code alert-danger">{reasonMessage} </div>
                    ) : (
                      <span></span>
                    ) }
                    <div className="inner-input">
                      <FontAwesomeIcon icon={faUserShield} />
                      <input
                        className="form-control"
                        type="text"
                        name="code"
                        maxLength="10"
                        onChange={this.handleCodeChange}
                        value={code}
                        placeholder="Enter Code"
                        onKeyPress={this.onSubmitCodePress} 
                        required                      
                      />
                    </div>
                    <button disabled={codeButtonDisable} type="submit" className="btn btn-block login-btn">
                      Submit code
                    </button>
                    {/* Testing only. Must be enabled in API */}
                    { otuData && otuData.SecretCodeDoNotPublish ? (
                      <Fragment>
                      <div className="warn-code">Code displayed only for testing: {otuData.SecretCodeDoNotPublish} <br></br>The code will be emailed.</div>
                      </Fragment>
                    ) : (
                      <span></span>
                    )}               
                  </form>;
            case "enterpass": 
                const inputType = passVisibilityIcon == faEyeSlash ? "text" : "password"
                return <form onSubmit={this.sendPwd}>
                    { isInvalidPassword ? (
                      <div className="invalid-code alert-danger">{reasonMessage} </div>
                    ) : (
                      <span></span>
                    ) }
                    <div className="inner-input-password">
                      {/* <FontAwesomeIcon icon={faKey} /> */}
                      <a onClick={this.togglePassVisibilityChange}><FontAwesomeIcon icon={passVisibilityIcon} /></a>
                      <input                         
                        className="form-control"
                        type={inputType} 
                        maxLength="50" 
                        minLength="6" 
                        name="pword"
                        onChange={this.handlePwordChange}
                        value={pword}
                        placeholder="Enter new password"
                        onKeyPress={this.onSubmitNewPassword} 
                        required                      
                      />
                    </div>    
                    <button disabled={saveButtonDisable} type="submit" className="btn btn-block login-btn">
                      Save
                    </button>
                  </form>;
            default:
                return <span> </span>;
        }
      }else{
        const initialMode = window.location.pathname && window.location.pathname.indexOf('forgotpw') > -1 ? 'password' : 'username';
        switch (initialMode) {
            case "password":
            case "username":
                return <form onSubmit={this.getTk}>
                    <div className="inner-input">
                      <FontAwesomeIcon icon={faEnvelope} />
                      <input                         
                        className="form-control"
                        type="email"
                        name="email"
                        maxLength="250"
                        onChange={this.handleEmailChange}
                        value={email}
                        placeholder="Email"
                        onKeyPress={this.onEnterPress}
                        autoComplete="email" 
                        required 
                      />
                    </div>
                    <button disabled={emailButtonDisable} type="submit" className="btn btn-block login-btn">
                      Next
                    </button>                    
                  </form>;
            default:
                return <h3>Statescape</h3>;
        }
      }
  };

  render() {
    const numberOfAttempts = this.state.countOfSubmission;
    const { email, pass } = this.state;
    const { otuData, auth, displayMode } = this.props;

    return (
      <Fragment>
        <header className="login-header">
          <a href="http://www.statescape.com/">
            <img src={StatescapeLogo} alt="logo" />
          </a>
        </header>
        <div className="login-body">
          <br />
          <div className="login-form-wrapper">
            <div className="login-form">
              <div className="login-icon-wrapper">
                <img src={LoginIcon} alt="sign in icon" />
              </div>
              <div className="login-inputs-wrapper">

                {this.renderTitle()}

                {this.renderBody()}

                {/* { cToken1 ? (
                  <div>token exists</div>
                ) : (
                  
                  <form onSubmit={this.getTk}>
                    <div className="inner-input">
                      <FontAwesomeIcon icon={faEnvelope} />
                      <input
                        className="form-control"
                        type="email"
                        name="email"
                        onChange={this.handleEmailChange}
                        value={email}
                        placeholder="Email"
                        onKeyPress={this.onEnterPress}
                        autoComplete="email" 
                        required 
                      />
                    </div>
                    <button type="submit" className="btn btn-block login-btn">
                      Next
                    </button>                    
                  </form>
                )} */}

              </div>
            </div>
          </div>
        </div>
        <footer>
          <div className="d-flex align-items-center h-100 justify-content-between">
            <div><nobr>&#xA9; StateScape {new Date().getFullYear()}</nobr> &nbsp;
            <span className="privacy-link">
            <a href="https://www.statescape.com/about/privacypolicy/">Privacy Policy</a>
            </span>
            </div>
            <div className="terms-link">
            <a href="https://www.statescape.com/about/clienttermsofuse/">Terms of Use</a>
            </div>
            <div className="support-link">
              <a href="mailto:customer.support.mail@statescape.com">
                support@statescape.com
              </a>
            </div>
          </div>
        </footer>
      </Fragment>
    );
  }

  static propTypes = {
    forgotPw: PropTypes.func,
    validateCode: PropTypes.func, 
    updateStrongPw: PropTypes.func, 
    successSubmit: PropTypes.bool,
    otuData: PropTypes.object,
    displayMode: PropTypes.string,
    isInvalidCode: PropTypes.bool,
    isInvalidPassword: PropTypes.bool,
  };
}

const mapDispatchToProps = {
  forgotPw,
  validateCode,
  updateStrongPw,
};

const mapStateToProps = (state) => ({
  auth: state.auth,  
  //isLoggingIn: state.auth.isLoggingIn,
  successSubmit: state.auth.successSubmit,
  otuData: state.auth.otuData,
  displayMode: state.auth.displayMode,
  isInvalidCode: state.auth.isInvalidCode,
  isInvalidPassword: state.auth.isInvalidPassword,
  reasonMessage: state.auth.reasonMessage,
});


export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassView);



// WEBPACK FOOTER //
// ./src/routes/ForgotPassword/ForgotPassword.js